// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X9vw","clinicsSelect":"styles_clinicsSelect__30r3x"};